import { useCallback } from 'react';

import TextField from '@gogame/ui/TextField';

import { EMPTY_DECIMAL } from '../constants';

export const Decimal = ({ value, onChange }) => {
  const handleChange = useCallback((e, value) => {
    onChange(e, value === '' ? EMPTY_DECIMAL : value);
  }, []);
  return (
    <TextField
      width={'76px'}
      value={value === EMPTY_DECIMAL ? '' : value}
      onChange={handleChange}
      autoFocus={true}
      type={'number'}
      label={'Value'}
    />
  );
};
